export default "__VITE_ASSET__DDpEwL_t__"